import React, { useState } from 'react';
import { Modal, message, Typography } from 'antd';
import { lanzarSync } from '../../api/brevoSyncApi';

const { Text } = Typography;

interface LaunchModalProps {
  visible: boolean;
  hasRunning: boolean;
  onClose: () => void;
  onLaunched: () => void;
}

const LaunchModal: React.FC<LaunchModalProps> = ({ visible, hasRunning, onClose, onLaunched }) => {
  const [launching, setLaunching] = useState(false);

  const handleLaunch = async () => {
    setLaunching(true);
    try {
      await lanzarSync();
      message.success('Sincronización lanzada correctamente');
      onClose();
      onLaunched();
    } catch (error: any) {
      if (error?.response?.status === 409) {
        message.warning('Ya hay una sincronización en curso');
      } else {
        message.error('Error al lanzar la sincronización');
      }
    } finally {
      setLaunching(false);
    }
  };

  return (
    <Modal
      open={visible}
      title="Lanzar sincronización"
      okText="Lanzar"
      cancelText="Cancelar"
      onOk={handleLaunch}
      onCancel={onClose}
      confirmLoading={launching}
      okButtonProps={{ disabled: hasRunning }}
    >
      {hasRunning ? (
        <Text type="warning">Ya hay una sincronización en curso. No se puede lanzar otra.</Text>
      ) : (
        <div>
          <p>Se va a lanzar una sincronización completa de contactos con Brevo.</p>
          <p><Text type="secondary">Tarda entre 30 y 90 minutos. Puedes cerrar esta página y volver más tarde para ver el resultado.</Text></p>
        </div>
      )}
    </Modal>
  );
};

export default LaunchModal;
